/**
 * Arduino Store Select Popup
 * A popup for selecting EU/US store
 */

(function() {
    function toggleStorePopup(event = null) {
        if(event) {
            event.preventDefault();
        }

        // simulate click on the Selectors apps standard selector
        const toggleWrap = document.querySelector('.needsclick.sel-fixed');
        const toggle = toggleWrap.shadowRoot.querySelector('.sel-bottom');

        toggle.click();
    }

    function init() {
        // add listeners for popup toggles
        const popupToggles = [
            '.ino-market-select', 
            '.ino-footer__region',
        ];

        for(let toggle of popupToggles) {
            const toggleElement = document.querySelector(toggle);
            if(toggleElement) {
                toggleElement.addEventListener('click', toggleStorePopup);
            }
        }
    }

    window.addEventListener('load', init);
})();
